import React from 'react';
import {useHistory} from 'react-router-dom';
import Loading from '../Components/Loading';
import '../CSS/Opening.css';
import { motion} from 'framer-motion';
import { pageTransition, pageStyle, pageVariants } from '../Components/Animations/Transition';
import {getUrl} from '../Functions.js';

function Opening() {

    const history  = useHistory();
    const validate=()=>{
        if(localStorage.getItem("loggedIn")==="true"){
            let tempDetails = JSON.parse(localStorage.getItem('details'));
            const options = {
              method : 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ 
                userName: tempDetails.userName, 
                password : tempDetails.password 
              })
            }
            fetch(getUrl() + 'login', options)
                .then(response => response.json()).then(
                  data =>{    
                    if(data.retry===true){
                      console.log("retrying...");
                      validate();
                    }else{
                      fetch(getUrl() + 'login', options).then(response=>response.json()).then(
                        data=>{
                          if(data.check===false){

                            }else{

                            localStorage.setItem("loggedIn", true);
                            localStorage.setItem("cookie",data.cookies);
                            localStorage.setItem("details", JSON.stringify(tempDetails));
                            history.push("/home",{state:{cookies : data.cookies}})
                          }
                      }
                      );
                    }
                  }
                );
          }else{
              history.push("/login");
          }
    }

    validate();

  return (
    <motion.div className="Opening"
    initial="initial"
    animate="in"
    exit="out"
    style={pageStyle}
    variants={pageVariants}
    transition={pageTransition}>
        <div>

        </div>
        <Loading  color="#ffffff"/>

      <div className="NOTE">
        <div className="NoteText">
            Note:
        </div>
        <div className="MessageText">
           1. Please wait whenever you see above animation
        </div>
        <div className="MessageText">
           2. All data remains in local storage only
        </div>
        <div className="MessageText">
           3. Loading time completely depends on Amity University Servers
        </div>

      </div>
    </motion.div>
  );
}

export default Opening;